export default "__VITE_ASSET__CISIYu28__"